import { AllEntryTypes } from '../models/Content';

export enum BlockVisibility {
    LoggedOut = 'loggedOut',
    LoggedIn = 'loggedIn',
}

export type BlockVisibilityValue = `${BlockVisibility}`;

export const shouldRenderBlock = (visibility: BlockVisibilityValue | undefined, isAuthorized: boolean): boolean => {
    if (visibility === BlockVisibility.LoggedOut) {
        return !isAuthorized;
    }

    if (visibility === BlockVisibility.LoggedIn) {
        return isAuthorized;
    }

    return true;
};

export const getBlockVisibility = (contentItem?: AllEntryTypes): BlockVisibilityValue | undefined => {
    if (!contentItem?.fields || !('visibility' in contentItem.fields)) {
        return undefined;
    }

    const { visibility } = contentItem.fields;

    if (visibility === BlockVisibility.LoggedOut || visibility === BlockVisibility.LoggedIn) {
        return visibility;
    }

    return undefined;
};
